import { useQuery } from "@tanstack/react-query";
import serialsClient from "../../../api/serials";

const useGenerationStatus = () => {
  return useQuery({
    queryKey: ["serials", "generation-status"],
    queryFn: () => serialsClient.generationStatus(),
    refetchInterval: (query) => (query.state.data?.running ? 5000 : 30000),
  });
};

export default useGenerationStatus;
